import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';
import { Course } from '@shared/models/entities/course.model';

@Injectable({ providedIn: 'root' })
export class CoursesService extends ApiBaseService<Course> {
  constructor() {
    super('courses');
  }
}
